import { Link, useLocation } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { getMe, logout as apiLogout, type MeUser } from '../lib/api';

export default function SiteHeader() {
  const loc = useLocation();
  const [me, setMe] = useState<MeUser | null | undefined>(undefined);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    let cancelled = false;
    getMe()
      .then((u) => { if (!cancelled) setMe(u); })
      .catch(() => { if (!cancelled) setMe(null); });
    return () => { cancelled = true; };
  }, [loc.pathname]);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  async function onLogout() {
    await apiLogout();
    setMe(null);
  }

  const onHome = loc.pathname === '/';
  const anchor = (id: string) => (onHome ? `#${id}` : `/#${id}`);

  return (
    <header className={`site-header${scrolled ? ' is-scrolled' : ''}`}>
      <div className="site-header-inner">
        <div className="brand-block">
          <Link to="/" className="brand-lockup" aria-label="念影首页">
            <img className="brand-mark" src="/assets/brand/logo-mark.png" alt="" width={28} height={28} />
            <span className="brand">念影</span>
          </Link>
          <div className="brand-sub">专业遗像制作</div>
        </div>

        <nav className="site-nav" aria-label="主导航">
          <a href={anchor('process')}>制作说明</a>
          <a href={anchor('pricing')}>价格</a>
          <a href={anchor('cases')}>案例</a>
          <a href={anchor('faq')}>常见问题</a>
          <a href={anchor('about-privacy')}>关于与隐私</a>
        </nav>

        <div className="auth-links">
          {me === undefined ? null : me ? (
            <>
              <Link to="/account/orders">我的订单</Link>
              <button type="button" className="btn-secondary" style={{ minHeight: 40, padding: '8px 14px' }} onClick={onLogout}>
                退出
              </button>
            </>
          ) : (
            <>
              <Link to="/login">登录</Link>
              <Link to="/register" className="btn-primary" style={{ minHeight: 40, padding: '8px 14px' }}>
                注册
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
}
